// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__1Au0m","desabilitar":"OptionSelect_desabilitar__i70l0","focado":"OptionSelect_focado__E8Ra0","novo":"OptionSelect_novo__rd0y9"};